export default __webpack_public_path__ + "static/media/Tema 4-1 a.026d1ea0.png";